import ShopifySidebarElement from './SidebarElement';

export default ShopifySidebarElement;
